import React from "react";
import CommonMemberTable from "../commonModule/CommonMemberTable";

export default function MemberTable() {
  return (
    <div>
      <CommonMemberTable status="" title="All Members" />
    </div>
  );
}
